var React = require('react');

function FacebookCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.5999 11.9999C21.5999 6.69686 17.3029 2.3999 11.9999 2.3999C6.69686 2.3999 2.3999 6.69686 2.3999 11.9999C2.3999 16.5004 5.49878 20.2789 9.68054 21.3157V14.9337H7.6991V11.9999H9.68054V10.7365C9.68054 7.4687 11.1589 5.95574 14.3653 5.95574C14.9721 5.95574 16.0242 6.07478 16.4505 6.19382V8.8511C16.2239 8.82806 15.8322 8.81654 15.3407 8.81654C13.7663 8.81654 13.1596 9.41174 13.1596 10.9631V11.9999H16.2969L15.7593 14.9337H13.1634V21.5308C17.9173 20.9548 21.5999 16.9074 21.5999 11.9999Z","fill":"#1C232B"}));
}

FacebookCircle.displayName = "FacebookCircle";

FacebookCircle.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = FacebookCircle;

FacebookCircle.default = FacebookCircle;
